module.exports = __webpack_public_path__ + "static/media/p0301.59d76a59.png";